<template lang='pug'>
div
    ServicesSelectorLinks
    div.fullwidth(v-if="$route.params.lang == 'de'")

        div.title-container
            h1.product-title TE-Lokalisierung an Transformatoren und GIS
            .subtitle Teilentladungen (TE) können in Transformatoren und GIS durch Laufzeitmessungen von ultrahochfrequenten (UHF) und akustischen TE-Signalen oder der Kombination beider Methoden geortet werden. Dies kann sowohl im Prüffeld als auch vor Ort im laufenden Betrieb erfolgen.

        div.margin-bottom
            .column-container
                .column.center-content
                    Carousel(:perPage="1", autoplay=true, :autoplayTimeout="4000", loop=true, :centerMode="true", navigationEnabled=false, paginationPosition='bottom', paginationColor='#CCC', paginationActiveColor='#09F', adjustableHeight=false)
                        //- Slide
                        //-     div.image-container
                        //-         img.carousel-image(src='@/assets/svg/TransformerMeasurement.svg')
                        Slide
                            div.image-container
                                img.carousel-image(src='@/assets/photos/services/acoustical PD localization at transformer 2.jpg', alt='Akustische TE-Sensoren installiert an einem Leistungstransformator', title='Akustische TE-Sensoren installiert an einem Leistungstransformator')
                        Slide
                            div.image-container
                                img.carousel-image(src='@/assets/photos/services/UHFsensorTransformer.png', alt='UHF-TE-Sensor installiert an einem Leistungstransformator', title='UHF-TE-Sensor installiert an einem Leistungstransformator')
                        Slide
                            div.image-container
                                img.carousel-image(src='@/assets/photos/services/UHF-acoustical PD localization at transformer.jpg', alt='UHF und akustische TE-Ortung', title='UHF und akustische TE-Ortung')
                        Slide
                            div.image-container
                                img.carousel-image(src='@/assets/photos/services/result of acoustical PD localaization at power transformer.jpg', alt='TE-Ortungsergebnis', title='TE-Ortungsergebnis')
                    
                .column.factsandbluebox
                    .factbox
                        p Wir besitzen langjährige Erfahrung bei der Ortung von Teilentladungen onsite und offsite. Je nach Einsatzgebiet und Rahmenbedingungen kann eine Kombination von akustischen, elektrischen und UHF-Messsystemen und Sensoren verwendet werden. Bei kombinierten Messverfahren dienen elektrische oder UHF-Signale als Trigger für die akustische Laufzeitmessung. Dies ermöglicht auch die Detektion sehr kleiner akustischer Impulse, die normalerweise aufgrund der Rauschpegel nicht messbar wären, womit die Empfindlichkeit der Ortung fallabhängig signifikant erhöht werden kann. So können wir den Gegebenheiten vor Ort gerecht werden, um eine bestmögliche Lokalisierung zu erzielen.
                        .span.headline TE-Lokalisierungsmethoden:
                        ul
                            li Analyse von TE-Signalen im Zeitbereich mit der elektrischen und UHF-Messung
                            li Dreiphasen-Sterndiagramm
                            li Laufzeitbestimmung der UHF und akustischen TE-Messung
                            li Akustische Messung getriggert durch UHF-Signale zur Rauschunterdrückung durch Averaging

                    .bluebox
                        //- Downloadlink(text='Datenblatt (pdf, deutsch)', link="/pdf/Datenblatt HFIG-600.pdf")
                        //- Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet HFIG-600.pdf")
                        Maillink(to='support@bss-hs.de', sub='TE Ortung', text='Contact Us', size=30, strokeWidth=2)
                        Sitelink(to="/de/products/pdm600", text='UHF-TE-Monitoring System PDM-600')
                        Sitelink(to="/de/products/uhfsensors/overview", text='UHF-TE-Sensoren')
                    
        div.margin-bottom
            
            h1 Diagnosemessungen an Transformatoren
            p Wir bieten verschiedene Diagnosemessungen für Hersteller und Betreiber von Transformatoren an:
            p TE-Messung an Transformatoren und anderen Betriebsmitteln im Prüffeld oder vor Ort im Betrieb mit verschiedenen Messmethoden: 
            ul
                li elektrische TE-Messung im Bereich der IEC60270 und bei höheren Frequenzen
                li UHF-TE-Messung
                li akustische TE-Messung
                li TE-Messung mit Stromzangen (HFCTs) an Kabeln
                li TE-Messung an MS-Schaltanlagen mit TEV-Sensoren
            p Schwingungsüberwachung von Leistungstransformatoren
            ul
                li mechanische Betriebsmittelüberwachung
                li Detektion parasitärer Gleichströme durch das veränderte Schwingungsverhalten
            p Messung von parasitären Gleichströmen im Sternpunkt von Transformatoren
            p Dreiphasige, galvanisch getrennte Messung von Phasenströmen (AC & DC)  auf Hochspannungsseite



    div.fullwidth(v-if="$route.params.lang == 'en'")

        div.title-container
            h1.product-title PD Localization at Transformers and GIS
            .subtitle Partial discharges can be located in transformers and GIS by triangulation of time of flight measurements using ultra-high frequency (UHF) or acoustic signals of PD. This can be done at the manufacturer’s factory and also onsite with transformers in service.

        div.margin-bottom
            .column-container
                .column
                    Carousel(:perPage="1", autoplay=true, :autoplayTimeout="4000", loop=true, :centerMode="true", navigationEnabled=false, paginationPosition='bottom', paginationColor='#0CF', paginationActiveColor='#09F', adjustableHeight=true)
                        //- Slide
                        //-     div.image-container
                        //-         img.carousel-image(src='@/assets/svg/TransformerMeasurement.svg')
                        Slide
                            div.image-container
                                img.carousel-image(src='@/assets/photos/services/acoustical PD localization at transformer 2.jpg', alt='Acoustic PD Sensors at Power Transformer', title='Acoustic PD Sensors at Power Transformer')
                        Slide
                            div.image-container
                                img.carousel-image(src='@/assets/photos/services/UHFsensorTransformer.png', alt='UHF PD Sensor at Power Transformer', title='UHF PD Sensor at Power Transformer')
                        Slide
                            div.image-container
                                img.carousel-image(src='@/assets/photos/services/UHF-acoustical PD localization at transformer.jpg', alt='UHF and Acoustical PD Localization', title='UHF and Acoustical PD Localization')
                        Slide
                            div.image-container
                                img.carousel-image(src='@/assets/photos/services/result of acoustical PD localaization at power transformer.jpg', alt='PD Localization Result', title='PD Localization Result')
                .column.factsandbluebox
                    .factbox
                        p We provide long standing experience in partial discharge localization onsite and offsite. To meet the conditions of onsite requirements, we can combine different measurement methods in order to achieve the best possible localization result: we use a combination of acoustic, electric and UHF measurement systems and sensors depending on the individual application and environment.
                        p Combined measurement methods use electric or UHF signals as trigger for the acoustic time of flight estimation. Thus, very small acoustic pulses smaller than onsite high noise levels can be detected and the sensitivity of acoustic PD detection can be increased significantly
                        .span.headline PD localization methods:
                        ul
                            li time-domain signal analysis of electrical and UHF PD measurement
                            li three phase star diagram
                            li time of flight measurement of UHF and acoustic PD measurement
                            li acoustic PD measurement triggered by UHF for noise reduction by averaging

                    .bluebox
                        //- Downloadlink(text='Datenblatt (pdf, deutsch)', link="/pdf/Datenblatt HFIG-600.pdf")
                        //- Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet HFIG-600.pdf")
                        Maillink(to='support@bss-hs.de', sub='PD Localization', text='Contact Us', size=30, strokeWidth=2)
                        Sitelink(to="/en/products/pdm600", text='UHF PD Monitoring System PDM-600')
                        Sitelink(to="/en/products/uhfsensors/overview", text='UHF PD Sensors')
                    
        div.margin-bottom
            
            h1 Diagnostic Measurements at Transformers
            p We provide different diagnostic measurements for manufacturers and operators of transformers:
            p PD measurement at transformers and other equipment in the test lab or on-site in service using different PD measurement methods:
            ul
                li electrical PD measurement in IEC60270 range and above
                li electromagnetic PD measurement (UHF)
                li acoustic PD measurement
                li PD measurement using HFCTs at cable terminals
                li PD measurement using TEV sensors at MV switchgears
            p Vibration monitoring of power transformers
            ul 
                li mechanical monitoring
                li detection of parasitic DC currents using the changing vibration behaviour due to DC
            p Measurement of parasitic direct current (DC) in the neutral point of transformers
            p Three-phase, galvanically isolated measurement of phase currents (AC & DC) on high voltage potential


</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
    components: {
        Carousel,
        Slide,
    },
    meta: {
        de: {
            title: "BSS - Dienstleistungen - Diagnosemessungen",
            description:
                "Teilentladungs(TE)-Messungen und -Ortung an Transformatoren",
        },
        en: {
            title: "BSS - Services - Transformer Measurements",
            description: "PD Measurement and Localization at Transformers",
        },
    },
};
</script>

<style lang='sass' scoped>
.image-container
    width: 100%
    display: flex
    align-items: center
    justify-content: center
    object-fit: cover

    .carousel-image
        width: 100%
        // height: 300px
        @media(max-width: $mobile-breakpoint)
            width: auto
            height: 300px
</style>